import { SEND_DRAWING_SUCCESS, SEND_DRAWING_FAILED, RESET_DRAWING_STATUS } from "../actions/types";
export default function(
  state = {
    uploadStatus: null,
    dataURL: "https://picsum.photos/1000/700?image=0"
  },
  action
) {
  switch (action.type) {
    case SEND_DRAWING_SUCCESS:
      return { ...state, uploadStatus: "success", dataURL: action.payload };
    case SEND_DRAWING_FAILED:
      return { ...state, uploadStatus: "failed" };
    case RESET_DRAWING_STATUS:
      return { ...state, uploadStatus: null };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/drawnImageReducer.js